import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MixedSchema } from '@principle-theorem/editor';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import {
  TemplateType,
  type ITemplateContext,
} from '@principle-theorem/principle-core/interfaces';
import { TemplatePreviewComponent } from '../template-preview/template-preview.component';

export interface ITemplatePreviewDialogData {
  type: TemplateType;
  context: ITemplateContext;
  template: MixedSchema;
}

@Component({
  selector: 'pr-template-preview-dialog',
  templateUrl: './template-preview-dialog.component.html',
  styleUrls: ['./template-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, TemplatePreviewComponent],
})
export class TemplatePreviewDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ITemplatePreviewDialogData,
    public dialogRef: MatDialogRef<TemplatePreviewDialogComponent>
  ) {}
}
